<template>
  <div>
      
    <div class="highlight-wrapper" id="highlights">
      <div><h2>Highlights</h2></div>

      <div class="table-wrapper">
        <a-button type="primary" v-if="modeDetailHighlight" style="margin-bottom: 20px;" @click="show_all_highlights()">Show all highlights</a-button>

        <a-row :gutter="16" v-if="!modeDetailHighlight">
          <a-col :xs="24" :md="12" :lg="6">
            <a-input-search
              placeholder="Search by Brand / Description"
              @search="on_search_highlights($event)"
            />
          </a-col>
          <a-col :xs="24" :md="12" :lg="6">
            <a-select
              v-model:value="valueCategoryHighlight"
              show-search
              placeholder="Select a category"
              style="width: 100%"
              :options="categories"
              optionFilterProp="label"
              mode="multiple"
              @change="handle_change_category_highlights"
            ></a-select>
          </a-col>
        </a-row>

        <a-table :columns="columns" :data-source="dataSourceHighlight" :sticky="true" :expandRowByClick="true" :bordered="true" :defaultExpandedRowKeys="defaultExpendedRowHighlight">
          <template #expandedRowRender="{ record }">
            <p>{{ record.description }}</p>
            <p><label for="category">Category:</label> {{ record.category_title }}</p>
            <p><label for="category">Exhibitor:</label> <a :href="'https://www.indexnonwovens.com/en/page/index23-exhibitors-list-1416?exh_id=' + record.exhibitor_catalog_id" target="_blank">{{ record.exhibitor_cat_banner }}</a></p>
            <p><strong>Contact</strong><br>
            <a :href="'mailto:' + record.contact_email" target="_blank">{{ record.contact_first_name }} {{ record.contact_last_name }}</a></p>
          </template>
        </a-table>
      </div>
    </div> <!-- highlight-wrapper -->






    <div class="newlaunch-wrapper" id="newlaunches">
      <div><h2>New Launches</h2></div>

      <div class="table-wrapper">
        <a-button type="primary" v-if="modeDetailNewlaunch" style="margin-bottom: 20px;" @click="show_all_newlaunches()">Show all newlaunches</a-button>

        <a-row :gutter="16" v-if="!modeDetailNewlaunch">
          <a-col :xs="24" :md="12" :lg="6">
            <a-input-search
              placeholder="Search by Brand / Description"
              @search="on_search_newlaunches($event)"
            />
          </a-col>
          <a-col :xs="24" :md="12" :lg="6">
            <a-select
              v-model:value="valueCategoryNewlauch"
              show-search
              placeholder="Select a category"
              style="width: 100%"
              :options="categories"
              optionFilterProp="label"
              mode="multiple"
              @change="handle_change_category_newlaunches"
            ></a-select>
          </a-col>
        </a-row>

        <a-table :columns="columns" :data-source="dataSourceNewlaunch" :sticky="true" :expandRowByClick="true" :bordered="true" :defaultExpandedRowKeys="defaultExpendedRowNewlaunch">
          <template #expandedRowRender="{ record }">
            <p>{{ record.description }}</p>
            <p><label for="category">Category:</label> {{ record.category_title }}</p>
            <p><label for="category">Exhibitor:</label> <a :href="'https://www.indexnonwovens.com/en/page/index23-exhibitors-list-1416?exh_id=' + record.id" target="_blank">{{ record.exhibitor_cat_banner }}</a></p>
            <p><strong>Contact</strong><br>
            <a :href="'mailto:' + record.contact_email" target="_blank">{{ record.contact_first_name }} {{ record.contact_last_name }}</a></p>
          </template>
        </a-table>
      </div>
    </div> <!-- highlight-wrapper -->

  </div>

</template>

<script>



var edition_id = 20912; // INDEX 2023
// var edition_id = 13844; // INDEX 2020


const axios = require('axios').default;
var _ = require('lodash');


import { ref } from 'vue';


export default {
  name: 'App',
  components: {
  },
  methods: {
    perform_filter_highlights() {

      this.dataSourceHighlight = this.dataSourceOriginalHighlight;

      // filter by selected categories
      var selected_categories_highlights = this.selected_categories_highlights;
      if (!_.isEmpty(selected_categories_highlights)) {
        this.dataSourceHighlight = _.filter(this.dataSourceHighlight, function(o) { return selected_categories_highlights.includes(o.category_id); });
      }

      // // filter by search
      var selected_search_highlight = this.selected_search_highlight;
      if (!_.isEmpty(selected_search_highlight)) {
        selected_search_highlight = selected_search_highlight.toLowerCase();
        this.dataSourceHighlight = _.filter(this.dataSourceHighlight, function(o) { 
          return o.brand.toLowerCase().includes(selected_search_highlight) || o.description.toLowerCase().includes(selected_search_highlight); 
        });
      }
   },
    perform_filter_newlaunches() {

      this.dataSourceNewlaunch = this.dataSourceOriginalNewlaunch;

      // filter by selected categories
      var selected_categories_newlaunches = this.selected_categories_newlaunches;
      if (!_.isEmpty(selected_categories_newlaunches)) {
        this.dataSourceNewlaunch = _.filter(this.dataSourceNewlaunch, function(o) { return selected_categories_newlaunches.includes(o.category_id); });
      }

      // // filter by search
      var selected_search_newlaunch = this.selected_search_newlaunch;
      if (!_.isEmpty(selected_search_newlaunch)) {
        selected_search_newlaunch = selected_search_newlaunch.toLowerCase();
        this.dataSourceNewlaunch = _.filter(this.dataSourceNewlaunch, function(o) { 
          return o.brand.toLowerCase().includes(selected_search_newlaunch) || o.description.toLowerCase().includes(selected_search_newlaunch); 
        });
      }
   },
    get_exhibitors_infos(highlight_id_selected, newlaunch_id_selected) {
      axios.get("https://catalog-admin.palexpo.ch/index/highlights_for_website/" + edition_id).then((response) => {
        this.dataSourceOriginalHighlight = response.data.highlight_reformatted;
        this.dataSourceOriginalNewlaunch = response.data.newlaunch_reformatted;

        if (highlight_id_selected) {
          this.dataSourceHighlight = _.filter(this.dataSourceOriginalHighlight, function(o) { return highlight_id_selected == o.key; });
          this.modeDetailHighlight = true;
          this.dataSourceNewlaunch = this.dataSourceOriginalNewlaunch;
        } else if (newlaunch_id_selected) {
          this.dataSourceNewlaunch = _.filter(this.dataSourceOriginalNewlaunch, function(o) { 
            return newlaunch_id_selected == o.key; });
          this.modeDetailNewlaunch = true;
          this.dataSourceHighlight = this.dataSourceOriginalHighlight;
        } else {
          this.dataSourceHighlight = this.dataSourceOriginalHighlight;
          this.dataSourceNewlaunch = this.dataSourceOriginalNewlaunch;
        }

        this.categories = response.data.categories;
      });
    },
    show_all_highlights() {
      this.dataSourceHighlight = this.dataSourceOriginalHighlight;
      this.modeDetailHighlight = false;
      this.defaultExpendedRowHighlight = [];
    },
    show_all_newlaunches() {
      this.dataSourceNewlaunch = this.dataSourceOriginalNewlaunch;
      this.modeDetailNewlaunch = false;
      this.defaultExpendedRowNewlaunch = [];
    },
    on_search_highlights(selected_search_highlight) {
      this.selected_search_highlight = selected_search_highlight;
      this.perform_filter_highlights();            
    },
    on_search_newlaunches(selected_search_newlaunch) {
      this.selected_search_newlaunch = selected_search_newlaunch;
      this.perform_filter_newlaunches();            
    },
    handle_change_category_highlights(selected_categories_highlights) {
      this.selected_categories_highlights = selected_categories_highlights;
      this.perform_filter_highlights();
    },
    handle_change_category_newlaunches(selected_categories_newlaunches) {
      this.selected_categories_newlaunches = selected_categories_newlaunches;
      this.perform_filter_newlaunches();
    }
  },
  mounted() {
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);

    // get highlight param
    let highlight_id_selected = parseInt(params.get("highlight_id")); // returns a int
    this.defaultExpendedRowHighlight.push(highlight_id_selected);
    
    // get newlaunches param
    let newlaunch_id_selected = parseInt(params.get("newlaunch_id")); // returns a int
    this.defaultExpendedRowNewlaunch.push(newlaunch_id_selected);

    this.get_exhibitors_infos(highlight_id_selected, newlaunch_id_selected);
  },
  watch: {
    
    // valueCategories(selected_categories_highlights) {
    //   this.selected_categories_highlights = selected_categories_highlights;
    //   this.perform_filter_highlights();
    // },

  },
  data: function () {
    return {
      defaultExpendedRowHighlight: [],
      defaultExpendedRowNewlaunch: [],
      modeDetailHighlight: false,
      modeDetailNewlaunch: false,
      dataSourceHighlight: [],
      dataSourceNewlaunch: [],
      dataSourceOriginalHighlight: [],
      dataSourceOriginalNewlaunch: [],
      selected_search_highlight: '',
      selected_search_newlaunch: '',
      categories: [],
      columns: [
        {
          title: 'BrandName',
          dataIndex: "brand",
          key: "brand",
          fixed: true,
        },
        {
          title: 'Exhibitor',
          dataIndex: "exhibitor_cat_banner",
          key: "exhibitor_cat_banner",
          width: "300px",
          responsive: ['md'],
        },
      ],
      valueCategoryHighlight: ref(undefined),
      valueCategoryNewlauch: ref(undefined),
      selected_categories_highlights: [],
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  font-size: 32px;
}

#app .ant-table {
  font-size: 18px;
}

#app .description {
  font-size: 18px;
}

#app .ant-table-row-level-0 {
  cursor: pointer;
}

#app .table-wrapper {
  max-width: 1160px;
  margin: auto;
}

#app .ant-row .ant-col > span, #app .ant-row .ant-col > div {
  vertical-align: bottom;
  margin-bottom: 20px;
}

#app label {
  font-weight: bold;
}

</style>
